export default __webpack_public_path__ + "static/media/1350.b9b237ab.png";